export default {
  radio: 'with-gap radio-orange',
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/styles/menus.js